var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHexaogneLogementReady(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 242.941,
    height: 242.941,
    viewBox: "0 0 242.941 242.941",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 242.941,
    height: 242.941,
    rx: 55.382,
    ry: 55.382,
    fill: "#464dff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M185.908,77.184l-58.89-44.93c-1.51-1.16-3.42-1.76-5.34-1.71h-.01c-1.76.06-3.42.65-4.8,1.71l-58.9,44.93c-8.04,6.14-12.65,15.34-12.65,25.26v76.6c0,6.54,5.68,12.07,12.4,12.07h41.43c6.72,0,12.39-5.53,12.39-12.07l.01-40.1h20.79v40.1c0,6.54,5.68,12.07,12.39,12.07h41.44c6.72,0,12.39-5.53,12.39-12.07v-76.6c0-9.92-4.61-19.12-12.65-25.26ZM132.298,122.844h-20.72c-9.11,0-16.53,7.21-16.53,16.07v36.09h-33.23v-72.56c0-4.93,2.3-9.51,6.31-12.57l53.81-41.06,53.82,41.06c4.01,3.06,6.31,7.64,6.31,12.57v72.56h-33.23v-36.09c0-8.86-7.42-16.07-16.54-16.07Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexaogneLogementReady);
export default __webpack_public_path__ + "static/media/hexaogne-logement-ready.f91f15b23105e23271d4681e722bcd2d.svg";
export { ForwardRef as ReactComponent };